<template>
  <button
    :class="compact ? 'h-[52px]' : 'h-[56px]'"
    class="md:h-[64px] lg:h-[72px] w-full md:max-w-sm md:mx-auto bg-[#FEC629] rounded-[100px] flex flex-row justify-center items-center hover:bg-[#E6B025] transition-all duration-200 active:scale-[0.98] shadow-sm"
    @click="gotoMyGiving()"
  >
    <span
      class="flex ml-[8px] font-[700] text-[#21201E] text-[1rem] md:text-[1.25rem] lg:text-[1.375rem] leading-[1.5rem] md:leading-[1.75rem] lg:leading-[2rem]"
      >Give now</span
    >
  </button>
</template>

<script>
export default {
  props: {
    // Preselects this fund on Give now; it must be one of giving-options.vue's funds.
    fund: {
      type: String,
      default: null,
    },
    // 52px on a phone, as the BF2026 fulfilment frames draw it, rather than 56px.
    compact: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    gotoMyGiving() {
      const query = { fromgivenow: true };
      if (this.fund) query.fund = this.fund;
      this.$router.push({ path: '/my-giving/giving-options', query });
    },
  },
};
</script>
